export default function referenceDate(date) {
  // Parameter `date` may be:
  // - `null` for current date.
  // - A JSON date string.
  // - A Date object.

  const d = date ? new Date(date) : new Date();
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setMilliseconds(0);

  return d;
}
